// extracted by mini-css-extract-plugin
export default {"btn":"LeftArrow_btn__bzSrl","btnLeft":"LeftArrow_btnLeft__BKR92"};